var _g, _g2, _g3, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 39,
    viewBox: "0 0 35 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_199_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9289 5.64065L28.9575 4.65682C25.763 1.79265 20.8463 0.528088 15.4341 0.528088H8.77622C7.6929 0.526228 6.61983 0.737918 5.61838 1.15106C4.61692 1.56419 3.70672 2.17068 2.93982 2.93583C2.17292 3.70097 1.0925 4.84571 0.677074 5.84622C0.261646 6.84672 0.0474986 7.9193 0.0468801 9.00262L0.0468801 28.2779C0.0458099 29.6656 0.0944803 31.3989 0.764106 32.6143L16.2339 17.3191L27.9289 5.64065Z",
    fill: "url(#paint0_linear_199_4)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_199_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7162 8.90332L17.1611 18.4584L30.4604 31.7647C33.3646 28.5891 34.9642 24.3071 34.9642 19.4776C34.976 18.6151 34.9282 17.7553 34.8223 16.9041H34.7993L26.7162 8.90332Z",
    fill: "url(#paint1_linear_199_4)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_199_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4004 13.0087C33.5746 9.54529 31.6613 6.88638 30.1513 5.54395L27.7779 7.84188L34.7378 14.9197L34.4004 13.0087Z",
    fill: "url(#paint2_linear_199_4)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_199_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.23596 34.2658C1.94802 35.5597 3.07 36.7377 4.34163 37.4889C5.61326 38.2401 7.06332 38.636 8.54025 38.6351H15.2005C21.2167 38.6351 26.1948 36.382 29.4294 32.8502L16.0994 19.5203L1.23596 34.2658Z",
    fill: "url(#paint3_linear_199_4)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_199_4",
    x: 0.046875,
    y: 0.528076,
    width: 28.9106,
    height: 33.0299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.943712
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.471856
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_199_4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_199_4",
    x: 17.1611,
    y: 8.90332,
    width: 17.8048,
    height: 23.805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.943712
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.471856
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_199_4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_199_4",
    x: 27.7779,
    y: 5.54395,
    width: 6.9599,
    height: 10.3194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.943712
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.471856
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_199_4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_199_4",
    x: 1.23596,
    y: 19.5203,
    width: 28.1934,
    height: 20.0589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.943891
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.471946
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_199_4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_199_4",
    x1: -3.27735,
    y1: 23.0663,
    x2: 23.2764,
    y2: -3.56999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E2BC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E72479"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_199_4",
    x1: 14.4267,
    y1: 3.59022,
    x2: 37.1466,
    y2: 27.2963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E72479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4D30B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_199_4",
    x1: 34.9737,
    y1: 6.19039,
    x2: 30.4911,
    y2: 10.4371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48E06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E72479"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_199_4",
    x1: 8.47655,
    y1: 37.229,
    x2: 25.0411,
    y2: 24.6611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41AAF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#6CC3C1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.6aa3d507a48845e8437c38a6b169f3fe.svg";
export { ForwardRef as ReactComponent };